//Copy an answer on one question to another question on the same form. 
//Applies to checkbox-type question where 'copy_when_checked' is set to yes.
$(document).on('change', '.copy-fields', function (e) {
    var srcIDs = e.target.dataset.sourceSystemIds.split(',');
    var destIDs = e.target.dataset.destinationSystemIds.split(',');
    for (i = 0; i < srcIDs.length; i++){
      $(`div[data-system-id=${destIDs[i]}] input`).val($(`div[data-system-id=${srcIDs[i]}] input`).val())
    }
  });